<template>
  <div>
    <div :class="{ 'font-gen2-gradient-orange': $getSiteId() == 33, 'font-gen2-gradient-green': $getSiteId() == 35, 'font-gen2-gradient-dark': $getSiteId() != 35 && $getSiteId() != 33 }" style="font-size: 4rem;font-weight: 600; letter-spacing: 2px">Coming Soon</div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>

</style>